<app-page-list 
[data]="data" 
[columns]="columns" 
[queryService]="queryService" 
[canInsert]="false" 
[crud]="undefined" 
placeholderSearch="Ricerca per UUID punto campionamento"
[isRowClickable]="false"
[filterForm]="filterForm"
[customClickFunction]="customClickFunction">
  <div filters>
    <app-filters-panel>
      <app-filters-group title="Prelievo" [form]="filters" [filtersGroup]="['dataPrelievo_greaterThanOrEqual', 'dataPrelievo_lessThanOrEqual']">
        <app-input-date name="dataPrelievo_greaterThanOrEqual" label="Dal" placeholder="GG/MM/AAAA" [maxDate]="filters.controls['dataPrelievo_lessThanOrEqual'].value" [form]="filters"></app-input-date>
        <app-input-date name="dataPrelievo_lessThanOrEqual" label="Al" placeholder="GG/MM/AAAA" [minDate]="filters.controls['dataPrelievo_greaterThanOrEqual'].value" [form]="filters"></app-input-date>
      </app-filters-group>
      <mat-divider class="mx-3"></mat-divider>
     <!-- <app-filters-group title="Analisi" [form]="filters" [filtersGroup]="['dataAnalisi_greaterThanOrEqual', 'dataAnalisi_lessThanOrEqual']">
        <app-input-date name="dataAnalisi_greaterThanOrEqual" label="Dal" placeholder="GG/MM/AAAA" [form]="filters"></app-input-date>
        <app-input-date name="dataAnalisi_lessThanOrEqual" label="Al" placeholder="GG/MM/AAAA" [form]="filters"></app-input-date>
      </app-filters-group>-->
      <!--<mat-divider class="mx-3"></mat-divider>-->
      <!--<app-filters-group title="Stato" [form]="filters" [filtersGroup]="['status_in']">
        <app-input-toggle-group name="status_in" [form]="filters" [options]="statusOptions"></app-input-toggle-group>
      </app-filters-group>-->
    </app-filters-panel>
  </div>
</app-page-list>

